import React, { useCallback, useRef } from "react";
import { cn } from "../../lib/utils";

export function BoardReaction({
  element,
  selected,
  onSelect,
  onChange,
  onDelete,
  zoom,
}) {
  const dragRef = useRef(null);
  const size = element.size || 48;

  const onPointerDown = useCallback(
    (event) => {
      event.stopPropagation();
      onSelect(element.id);

      const startX = event.clientX;
      const startY = event.clientY;
      const originX = element.x;
      const originY = element.y;

      dragRef.current = { startX, startY, originX, originY };

      const onMove = (moveEvent) => {
        if (!dragRef.current) return;
        const dx = (moveEvent.clientX - dragRef.current.startX) / zoom;
        const dy = (moveEvent.clientY - dragRef.current.startY) / zoom;
        onChange(element.id, {
          x: dragRef.current.originX + dx,
          y: dragRef.current.originY + dy,
        });
      };

      const onUp = () => {
        dragRef.current = null;
        window.removeEventListener("pointermove", onMove);
        window.removeEventListener("pointerup", onUp);
      };

      window.addEventListener("pointermove", onMove);
      window.addEventListener("pointerup", onUp);
    },
    [element.id, element.x, element.y, onChange, onSelect, zoom],
  );

  return (
    <div
      className={cn(
        "absolute select-none",
        selected && "ring-2 ring-[var(--t-accent)] ring-offset-2 rounded-full",
      )}
      style={{
        left: element.x,
        top: element.y,
        fontSize: size,
        lineHeight: 1,
        zIndex: element.zIndex || 0,
        transform: "translate(-50%, -50%)",
      }}
      onPointerDown={onPointerDown}
      data-testid={`board-reaction-${element.id}`}
    >
      <span aria-hidden>{element.emoji}</span>
      {selected ? (
        <button
          type="button"
          className="absolute -right-1 -top-1 flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-[10px] text-white shadow"
          onPointerDown={(e) => e.stopPropagation()}
          onClick={(e) => {
            e.stopPropagation();
            onDelete(element.id);
          }}
        >
          ×
        </button>
      ) : null}
    </div>
  );
}
